import { render, staticRenderFns } from "./quotes-card.vue?vue&type=template&id=5b890eb5&scoped=true"
import script from "./quotes-card.vue?vue&type=script&lang=js"
export * from "./quotes-card.vue?vue&type=script&lang=js"
import style0 from "./quotes-card.vue?vue&type=style&index=0&id=5b890eb5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b890eb5",
  null
  
)

export default component.exports